export default "__VITE_ASSET__CHoHqcGx__"